var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2251_15930",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2251_15930)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00009 4.75C8.80118 4.75 8.61041 4.67098 8.46976 4.53033C8.32911 4.38968 8.25009 4.19891 8.25009 4C8.25009 3.80109 8.32911 3.61032 8.46976 3.46967C8.61041 3.32902 8.80118 3.25 9.00009 3.25H20.0001C20.199 3.25 20.3898 3.32902 20.5304 3.46967C20.6711 3.61032 20.7501 3.80109 20.7501 4V15C20.7501 15.1989 20.6711 15.3897 20.5304 15.5303C20.3898 15.671 20.199 15.75 20.0001 15.75C19.8012 15.75 19.6104 15.671 19.4698 15.5303C19.3291 15.3897 19.2501 15.1989 19.2501 15V5.811L4.53009 20.53C4.38792 20.6625 4.19987 20.7346 4.00557 20.7312C3.81127 20.7277 3.62588 20.649 3.48847 20.5116C3.35106 20.3742 3.27234 20.1888 3.26892 19.9945C3.26549 19.8002 3.33761 19.6122 3.47009 19.47L18.1891 4.75H9.00009Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpRightArrow);
export default __webpack_public_path__ + "static/media/up-right-arrow.93db174d91f102d1f0d7bd40b824299d.svg";
export { ForwardRef as ReactComponent };